import React from "react";
import logger from "../../../../../utils/LoggerFrontend";
import {
  LandscapeImage,
  IMAGE_TEMPLATES,
  VIDEO_TEMPLATES,
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO
} from "@talentbait/remotion-templates-talentbait";
import {
  TemplateWrapper,
  MainWrapper,
  CreativeAndUploaderWrapper
} from "./../../../Previews/TemplatePost/TemplatePost__Preview/styles";
import { TIKTOK_IMAGE_SIZE_SPEC } from "../print-post-editors/print-video-post-editor-tiktok/PrintVideoPostEditorTikTok.constants";
import VideoGeneratorPreview from "../../../Previews/VideoGenerator/VideoGenerator__Preview/VideoGenerator__Preview";
import {
  PhotoWrapper,
  TikTokWrapper
} from "../print-post-editors/print-video-post-editor-tiktok/PrintVideoPostEditorTikTok.styled";
import GlobalVideoGeneratorPreview from "../../../Previews/VideoGenerator/GlobalVideoGeneratorPreview/GlobalVideoGeneratorPreview";
import { getScaleFactor } from "../../../Previews/utils";
import {
  checkIfLandscape,
  getVideoSize,
  isOldDefaultTemplateStyle
} from "../../../Previews/TemplatePost/TemplatePost__Preview/utils";
import { PreviewStore, withRefluxStore } from "../../../../../Stores";

const TEMPLATES = {
  ...IMAGE_TEMPLATES,
  ...VIDEO_TEMPLATES
};
const TEMPLATES_INFO = {
  ...IMAGE_TEMPLATES_INFO,
  ...VIDEO_TEMPLATES_INFO
};

const PrintTemplateEditor = ({
  mediaAssets = [],
  mediaAssetsProps,
  selectedMediaAssetIndexToEdit,
  videoData,
  templatePreviewSizes,
  channel,
  // Store
  campaignData
}) => {
  const currentMediaAssetProp = mediaAssetsProps?.[selectedMediaAssetIndexToEdit]?.inputProps || {};
  const currentMediaAssetTemplateId = mediaAssetsProps?.[selectedMediaAssetIndexToEdit]?.templateId;

  logger.debug("TemplatePostPreview print", "called", {
    mediaAssets,
    mediaAssetsProps,
    selectedMediaAssetIndexToEdit,
    currentMediaAssetProp,
    currentMediaAssetTemplateId
  });

  const defaultTemplatePreviewDimensions = {
    width: "",
    minHeight: "",
    maxHeight: "",
    minAspect: "",
    maxAspect: ""
  };

  const imagePreviewSizes = templatePreviewSizes || defaultTemplatePreviewDimensions;

  const tikTokVideoPreview = (
    <TikTokWrapper>
      <PhotoWrapper>
        <VideoGeneratorPreview
          height={TIKTOK_IMAGE_SIZE_SPEC.height}
          width={TIKTOK_IMAGE_SIZE_SPEC.width}
          videoData={{ ...videoData, width: TIKTOK_IMAGE_SIZE_SPEC.width }}
        />
      </PhotoWrapper>
    </TikTokWrapper>
  );

  const imagePreview = () => {
    const TemplateComponent = TEMPLATES[currentMediaAssetTemplateId] || LandscapeImage;
    const template = TEMPLATES_INFO[currentMediaAssetTemplateId];

    const showLandscape = checkIfLandscape(template, currentMediaAssetProp?.orientation);

    const defaultHeight = showLandscape ? imagePreviewSizes.minHeight : imagePreviewSizes.maxHeight;

    const { videoHeight, videoWidth } = getVideoSize(
      currentMediaAssetTemplateId,
      imagePreviewSizes.width,
      defaultHeight
    );

    const scaleFactor = getScaleFactor(
      videoWidth,
      videoHeight,
      imagePreviewSizes.width,
      defaultHeight
    );

    const isOldCampaign = isOldDefaultTemplateStyle(
      campaignData?.status,
      campaignData?.createdDate
    );

    return (
      <CreativeAndUploaderWrapper>
        <TemplateWrapper
          minHeight={imagePreviewSizes.minHeight}
          maxHeight={imagePreviewSizes.maxHeight}
          width={imagePreviewSizes.width}
          height={defaultHeight}
        >
          {template?.type === "image" ? (
            <TemplateComponent
              {...currentMediaAssetProp}
              width={imagePreviewSizes.width}
              isNewCampaign={!isOldCampaign}
              isPrintView
            />
          ) : (
            <GlobalVideoGeneratorPreview
              remotionTemplate={TemplateComponent}
              width={videoWidth}
              height={videoHeight}
              videoData={{ ...currentMediaAssetProp }}
              scaleFactor={scaleFactor}
              orientation={template?.orientation}
              textLength={currentMediaAssetProp?.text?.length}
              showLandscape={showLandscape}
              isPrint
            />
          )}
        </TemplateWrapper>
      </CreativeAndUploaderWrapper>
    );
  };

  if (!mediaAssetsProps || mediaAssetsProps.length === 0) return null;

  const isTikTok =
    mediaAssetsProps[selectedMediaAssetIndexToEdit]?.templateId === "TikTokVideo" ||
    channel === "tiktok";

  return <MainWrapper>{isTikTok ? tikTokVideoPreview : imagePreview()}</MainWrapper>;
};

export default withRefluxStore(PrintTemplateEditor, [PreviewStore], ["campaignData"]);
